'use strict';

const setDefaultImgOnError = doc => () => {
	doc.addEventListener(
		'error',
		ev => {
			if (ev.target?.nodeName !== 'IMG') {
				return;
			}

			if (ev.target.src.endsWith('IMG_Unreachable.png')) {
				// The fallback itself failed; reassigning src would retrigger
				// the load and loop forever.
				return;
			}

			ev.target.dataset.unreachable = '1';
			ev.target.dataset.originalSrc = ev.target.src;
			ev.target.src = 'img/IMG_Unreachable.png';
		},
		{ capture: true }
	);
};

const setDefaultImgFactory = doc => {
	return {
		setDefaultImgOnError: setDefaultImgOnError(doc)
	};
};

module.exports = {
	setDefaultImgFactory
};
